import React, { useState, type FC, useEffect } from 'react';
import Table from '../components/Table';
import type DbDataModel from '../models/DbDataModel';
import api from '../services/api';
import LoadingView from '../components/LoadingView';

const Audit: FC = () => {
    const [data, setData] = useState<DbDataModel[]>([]);
    const [errorMessage, setErrorMessage] = useState('');
    const [loading, setLoading] = useState(true);

    const updateData = async () => {
        setLoading(true);
        const { auditReport, message, success } = await api.getAuditReport();
        if (success) {
            setData(auditReport);
            setErrorMessage('');
        } else {
            setData([]);
            setErrorMessage(
                message === 'Forbidden'
                    ? 'You do not have permission to access audit data.'
                    : message,
            );
        }

        setLoading(false);
    };

    useEffect(() => {
        void updateData();
    }, []);

    return (
        <>
            <div className="text-primary text-3xl pb-4">Reports</div>
            {loading && <LoadingView />}
            {!loading && errorMessage && (
                <div className="text-primary text-xl">
                    Error: {errorMessage}
                </div>
            )}
            {!loading && !errorMessage && <Table title="Audit" data={data} />}
        </>
    );
};

export default Audit;
